export default "__VITE_ASSET__BLECdQFm__"